(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bon-features-reasons"] && !Shopify.designMode) return;
  try {
    
  /** Delay before the 2nd icon after the 1st starts. */
  const ANIMATED_ICON_STAGGER_MS = 500;
  /** Delay before the 3rd icon after the 2nd starts. */
  const ANIMATED_ICON_STAGGER_FOLLOW_MS = 250;

  /**
   * SVG SMIL timeline APIs. Firefox exposes them but does not run animations.
   * @param {SVGSVGElement} svg
   * @returns {boolean}
   */
  function supportsSvgSmil(svg) {
    if (typeof svg.pauseAnimations !== 'function' || typeof svg.setCurrentTime !== 'function') {
      return false;
    }
    return !/\b(Firefox|FxiOS)\b/i.test(navigator.userAgent);
  }

  /**
   * @param {HTMLElement} section
   * @returns {AnimatedIcon[]}
   */
  function collectIcons(section) {
    return /** @type {AnimatedIcon[]} */ (
      [...section.querySelectorAll('animated-icon')].filter((node) => node instanceof AnimatedIcon)
    );
  }

  /**
   * Plays every <animated-icon> in the section once when any icon first scrolls
   * into view. Starts are staggered in DOM order (500ms then 250ms).
   * @param {HTMLElement} section
   */
  function bindFeatureIconSequence(section) {
    if (section.dataset.animatedIconSequenceBound === 'true') return;

    // customElements.define upgrades hosts one-by-one; the first connectedCallback
    // runs before siblings are AnimatedIcon yet. Wait until every host has upgraded.
    const hostCount = section.querySelectorAll('animated-icon').length;
    const icons = collectIcons(section);
    if (icons.length === 0 || icons.length < hostCount) return;

    section.dataset.animatedIconSequenceBound = 'true';

    /** Cancels staggered plays on section unload — not on sequence start. */
    const playAbort = new AbortController();
    /** Disconnects IO / scroll / rAF when playback starts or the section unloads. */
    const watchAbort = new AbortController();
    /** @type {number} */
    let rafId = 0;
    /** @type {ReturnType<typeof setTimeout>[]} */
    const staggerTimeouts = [];
    /** @type {IntersectionObserver | null} */
    let iconObserver = null;

    const stopWatching = () => {
      iconObserver?.disconnect();
      iconObserver = null;
      watchAbort.abort();
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = 0;
      }
    };

    const isIconInView = (icon) => {
      const rect = icon.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      if (rect.height <= 0 || rect.width <= 0) return false;
      return rect.top < vh * 0.9 && rect.bottom > vh * 0.1;
    };

    const playStaggered = () => {
      if (section.dataset.animatedIconSequencePlayed === 'true') return;

      section.dataset.animatedIconSequencePlayed = 'true';
      stopWatching();

      // Wait two frames so SVG layout/paint exists before SMIL starts. Starting in the
      // same turn as custom-element upgrade often leaves getCurrentTime() stuck at 0,
      // then the hold timeout bakes the finished frame (looks like “skip to end”).
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (playAbort.signal.aborted) return;

          for (const icon of icons) icon.ensurePausedAtStart();

          // 1st at 0ms, 2nd after 500ms, 3rd after another 250ms (750ms total).
          let delay = 0;
          for (let i = 0; i < icons.length; i += 1) {
            const startDelay = delay;
            const id = setTimeout(() => {
              if (playAbort.signal.aborted) return;
              icons[i].playNow();
            }, startDelay);
            staggerTimeouts.push(id);
            if (i === 0) delay += ANIMATED_ICON_STAGGER_MS;
            else delay += ANIMATED_ICON_STAGGER_FOLLOW_MS;
          }
        });
      });
    };

    const tryPlayWhenVisible = () => {
      if (section.dataset.animatedIconSequencePlayed === 'true') return;
      for (const icon of icons) {
        if (isIconInView(icon)) {
          playStaggered();
          return;
        }
      }
    };

    iconObserver = new IntersectionObserver(
      (entries) => {
        if (section.dataset.animatedIconSequencePlayed === 'true') return;
        if (entries.some((entry) => entry.isIntersecting)) playStaggered();
      },
      { threshold: [0, 0.15, 0.35] }
    );

    for (const icon of icons) iconObserver.observe(icon);

    // Backdrop-filter can make IO report 0; recover on scroll/resize + brief warmup.
    window.addEventListener('scroll', tryPlayWhenVisible, {
      passive: true,
      signal: watchAbort.signal,
    });
    window.addEventListener('resize', tryPlayWhenVisible, {
      passive: true,
      signal: watchAbort.signal,
    });

    const pollStart = performance.now();
    const poll = () => {
      if (watchAbort.signal.aborted || section.dataset.animatedIconSequencePlayed === 'true') {
        rafId = 0;
        return;
      }
      tryPlayWhenVisible();
      if (performance.now() - pollStart > 500) {
        rafId = 0;
        return;
      }
      rafId = requestAnimationFrame(poll);
    };
    rafId = requestAnimationFrame(poll);

    // Shopify fires section events on the `.shopify-section` wrapper, not inner roots.
    const unloadRoot = section.closest('.shopify-section') ?? section;
    unloadRoot.addEventListener(
      'shopify:section:unload',
      () => {
        for (const id of staggerTimeouts) clearTimeout(id);
        stopWatching();
        playAbort.abort();
      },
      { once: true }
    );
  }

  /**
   * Plays a nested SMIL-animated <svg> once as part of the section sequence,
   * then holds its final frame. Click/tap remounts and replays (silent easter egg).
   */
  class AnimatedIcon extends HTMLElement {
    /** @type {SVGSVGElement | null} */
    #svg = null;
    /** Original markup for remount/replay after baking the finished frame. */
    #sourceMarkup = '';
    /** @type {ReturnType<typeof setTimeout> | 0} */
    #timeout = 0;
    /** @type {AbortController | null} */
    #abortController = null;
    #hasPlayed = false;
    #isPlaying = false;

    connectedCallback() {
      const svg = this.querySelector('svg');
      if (!(svg instanceof SVGSVGElement)) return;

      this.#svg = svg;
      this.#sourceMarkup = svg.outerHTML;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!supportsSvgSmil(svg) || reducedMotion) {
        // Firefox has no SMIL; reduced-motion skips playback — bake the finished icon.
        this.#bakeFinishedFrame();
        return;
      }

      this.#pauseAtStart();
      this.#enableReplay();

      const section = this.closest('.bon-features-reasons');
      if (section instanceof HTMLElement) {
        bindFeatureIconSequence(section);
      }
    }

    disconnectedCallback() {
      clearTimeout(this.#timeout);
      this.#abortController?.abort();
      this.#abortController = null;
    }

    /**
     * Start this icon's SMIL animation. Used by the section sequencer and click replay.
     * @param {object} [options]
     * @param {boolean} [options.force]
     */
    playNow({ force = false } = {}) {
      if (!this.#svg || !supportsSvgSmil(this.#svg)) return;
      if (!force && (this.#hasPlayed || this.#isPlaying)) return;
      if (!this.#sourceMarkup) return;

      clearTimeout(this.#timeout);
      this.#hasPlayed = true;
      this.#isPlaying = true;

      this.#startSmilPlayback({ allowRetry: true });
    }

    /**
     * @param {object} [options]
     * @param {boolean} [options.allowRetry]
     */
    #startSmilPlayback({ allowRetry = false } = {}) {
      // Remount only when SMIL was baked away (replay) or missing.
      const needsRemount = !this.#svg?.querySelector('animate, animateTransform, set');
      if (needsRemount) {
        const siblingSnapshots = this.#snapshotSiblings();
        const template = document.createElement('template');
        template.innerHTML = this.#sourceMarkup.trim();
        const clone = template.content.querySelector('svg');
        if (!(clone instanceof SVGSVGElement)) {
          this.#isPlaying = false;
          return;
        }
        this.#svg.replaceWith(clone);
        this.#svg = clone;
        this.#restoreSiblings(siblingSnapshots);
      }

      const durationMs = this.#getDurationMs();
      this.#armDashOffsets();
      this.#svg.pauseAnimations();
      this.#svg.setCurrentTime(0);
      this.#svg.unpauseAnimations();

      this.#watchUntilFinished({ durationMs, allowRetry });
    }

    /**
     * Hold/bake only after SMIL advances. If time stays ~0, remount+retry once
     * instead of baking the end frame (which looks like skipping the animation).
     * @param {object} options
     * @param {number} options.durationMs
     * @param {boolean} options.allowRetry
     */
    #watchUntilFinished({ durationMs, allowRetry }) {
      const startedAt = performance.now();
      const endSec = Math.max(durationMs / 1000 - 0.05, 0);
      let sawProgress = false;

      const tick = () => {
        const svg = this.#svg;
        if (!svg) {
          this.#isPlaying = false;
          return;
        }

        const t = svg.getCurrentTime();
        const elapsed = performance.now() - startedAt;
        if (t > 0.05) sawProgress = true;

        if (t >= endSec || (sawProgress && t >= durationMs / 1000 - 0.02)) {
          this.#holdFinishedFrame();
          this.#isPlaying = false;
          return;
        }

        // Stalled: wall clock passed but SMIL never moved — retry once from source.
        if (!sawProgress && elapsed > Math.min(durationMs, 800)) {
          if (allowRetry) {
            const siblingSnapshots = this.#snapshotSiblings();
            const template = document.createElement('template');
            template.innerHTML = this.#sourceMarkup.trim();
            const clone = template.content.querySelector('svg');
            if (clone instanceof SVGSVGElement) {
              this.#svg.replaceWith(clone);
              this.#svg = clone;
              this.#restoreSiblings(siblingSnapshots);
            }
            this.#startSmilPlayback({ allowRetry: false });
            return;
          }
          this.#holdFinishedFrame();
          this.#isPlaying = false;
          return;
        }

        if (elapsed > durationMs + 1000) {
          this.#holdFinishedFrame();
          this.#isPlaying = false;
          return;
        }

        this.#timeout = setTimeout(tick, 50);
      };

      this.#timeout = setTimeout(tick, 50);
    }

    /** Keep this icon frozen until playNow runs (pause only — no seek). */
    ensurePausedAtStart() {
      if (this.#hasPlayed || this.#isPlaying) return;
      // pauseAnimations only — setCurrentTime(0) on waiters can zero a playing sibling.
      this.#svg?.pauseAnimations();
      this.#armDashOffsets();
    }

    /**
     * @returns {{ node: AnimatedIcon, t: number, paused: boolean, hasPlayed: boolean, isPlaying: boolean }[]}
     */
    #snapshotSiblings() {
      const root = this.closest('.bon-features-reasons');
      if (!(root instanceof HTMLElement)) return [];
      return [...root.querySelectorAll('animated-icon')]
        .filter((node) => node !== this && node instanceof AnimatedIcon)
        .map((node) => ({
          node: /** @type {AnimatedIcon} */ (node),
          t: node.#svg?.getCurrentTime() ?? 0,
          paused: node.#svg?.animationsPaused() ?? true,
          hasPlayed: node.#hasPlayed,
          isPlaying: node.#isPlaying,
        }));
    }

    /**
     * Chromium can zero other inline SVG timelines when one remounts.
     * @param {{ node: AnimatedIcon, t: number, paused: boolean, hasPlayed: boolean, isPlaying: boolean }[]} snapshots
     */
    #restoreSiblings(snapshots) {
      for (const snap of snapshots) {
        const svg = snap.node.#svg;
        if (!svg || !supportsSvgSmil(svg)) continue;
        if (snap.isPlaying) {
          svg.pauseAnimations();
          svg.setCurrentTime(snap.t);
          if (!snap.paused) svg.unpauseAnimations();
        } else if (snap.hasPlayed) {
          // Finished icons are baked — remount side effects cannot blank them.
          snap.node.#holdFinishedFrame();
        }
      }
    }

    #enableReplay() {
      this.#abortController?.abort();
      this.#abortController = new AbortController();
      this.addEventListener('click', () => this.playNow({ force: true }), {
        signal: this.#abortController.signal,
      });
    }

    #getDurationMs() {
      const nodes = this.#svg?.querySelectorAll('animate, animateTransform');
      let max = 2;
      if (nodes) {
        for (const node of nodes) {
          const parsed = parseFloat(node.getAttribute('dur') ?? '');
          if (!Number.isNaN(parsed) && parsed > max) max = parsed;
        }
      }
      return max * 1000;
    }

    #armDashOffsets() {
      const svg = this.#svg;
      if (!svg) return;
      for (const node of svg.querySelectorAll('[stroke-dasharray]')) {
        const length = node.getAttribute('stroke-dasharray');
        if (length) node.setAttribute('stroke-dashoffset', length);
      }
    }

    #pauseAtStart() {
      const svg = this.#svg;
      if (!svg) return;
      svg.pauseAnimations();
      svg.setCurrentTime(0);
      this.#armDashOffsets();
    }

    /**
     * Lock the finished frame by baking static transforms (strip SMIL).
     * Seeking alone is fragile: remounting a sibling SVG can zero this
     * timeline and leave scale(0) icons blank. Bake survives that.
     */
    #holdFinishedFrame() {
      if (!this.#svg) return;
      this.#bakeFinishedFrame();
    }

    /**
     * Force the finished icon without SMIL (Firefox / reduced-motion).
     * Rewrites base transforms/visibility/dashoffsets, then strips animate nodes.
     */
    #bakeFinishedFrame() {
      const svg = this.#svg;
      if (!svg) return;

      for (const anim of [...svg.querySelectorAll('animateTransform')]) {
        const target = anim.parentElement;
        if (!(target instanceof SVGElement)) continue;
        const type = anim.getAttribute('type') || 'translate';
        const values = (anim.getAttribute('values') || '')
          .split(';')
          .map((part) => part.trim())
          .filter(Boolean);
        const finalValue = anim.getAttribute('to') || values.at(-1);
        if (!finalValue) continue;

        if (type === 'scale') {
          const parts = finalValue.split(/[\s,]+/);
          const sx = parts[0] ?? '1';
          const sy = parts[1] ?? sx;
          target.setAttribute('transform', `scale(${sx}, ${sy})`);
        } else if (type === 'rotate') {
          const angle = finalValue.split(/[\s,]+/)[0] ?? '0';
          target.setAttribute('transform', `rotate(${angle})`);
        } else if (type === 'translate') {
          const parts = finalValue.split(/[\s,]+/);
          const tx = parts[0] ?? '0';
          const ty = parts[1] ?? '0';
          target.setAttribute('transform', `translate(${tx}, ${ty})`);
        }
        anim.remove();
      }

      for (const anim of [...svg.querySelectorAll('animate[attributeName="visibility"]')]) {
        const target = anim.parentElement;
        if (target instanceof SVGElement) target.setAttribute('visibility', 'visible');
        anim.remove();
      }

      for (const node of svg.querySelectorAll('[visibility="hidden"]')) {
        node.setAttribute('visibility', 'visible');
      }

      for (const node of svg.querySelectorAll('[stroke-dasharray]')) {
        node.setAttribute('stroke-dashoffset', '0');
      }

      for (const anim of svg.querySelectorAll('animate, set')) {
        anim.remove();
      }

      this.#hasPlayed = true;
    }
  }

  if (!customElements.get('animated-icon')) {
    customElements.define('animated-icon', AnimatedIcon);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bon-scroll-stats"] && !Shopify.designMode) return;
  try {
    
  class BonScrollStatsComponent extends HTMLElement {
    #observer = null;
    #section = null;
    #cards = [];
    #stages = [];
    #stickyTop = 16;
    #started = false;
    #active = 0;
    #maxActive = 0; /* highest card index reached */
    #ticking = false;
    #lastProgress = 0;
    #smoothedProgress = 0;
    #lastTimestamp = 0;
    #userClicked = false;
    #isCompleted = false;

    connectedCallback() {
      if (!window.matchMedia('(min-width: 750px)').matches) return;

      this.#section = this.closest('.bon-scroll-stats') || this;
      this.#cards = Array.from(this.querySelectorAll('[ref="cards[]"]'));
      this.#stages = Array.from(this.querySelectorAll('[ref="stages[]"]'));
      this.#updateStickyTop();

      if (!this.#cards.length) return;

      this.#setActive(0);
      this.#setupCardClickHandlers();

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.classList.add('is-started');
        return;
      }

      this.#observer = new IntersectionObserver(this.#handleIntersection, {
        threshold: 0.2,
        rootMargin: '0px 0px -15% 0px',
      });

      this.#observer.observe(this);
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
      this.#observer = null;
      // ensure listeners are removed in case component is torn down
      window.removeEventListener('scroll', this.#handleScroll);
      window.removeEventListener('resize', this.#handleResize);
      this.#section = null;
      this.#cards = [];
      this.#stages = [];
    }

    #handleIntersection = (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        this.#startAnimation();
        break;
      }
    };

    #startAnimation() {
      if (this.#started) return;
      this.#started = true;
      this.classList.add('is-started');

      // add event listeners directly; we will remove them manually later
      const options = { passive: true };

      window.addEventListener('scroll', this.#handleScroll, options);
      window.addEventListener('resize', this.#handleResize, options);

      this.#handleScroll();
      this.#observer?.disconnect();
      this.#observer = null;
    }

    #handleScroll = () => {
      if (this.#ticking) return;
      this.#ticking = true;

      requestAnimationFrame(() => {
        this.#ticking = false;
        this.#updateActiveByScroll();
      });
    };

    #handleResize = () => {
      this.#updateStickyTop();
      this.#handleScroll();
    };

    #updateStickyTop() {
      const headerHeight = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
      this.#stickyTop = headerHeight + 16;
    }

    #updateActiveByScroll() {
      // If user has clicked a card, don't override with scroll-based changes
      if (this.#userClicked) return;

      const cards = this.#cards;
      if (!cards.length) return;

      const section = this.#section || this;
      const rect = section.getBoundingClientRect();
      const viewportHeight = Math.max(window.innerHeight, 1);
      // Spaced deeper linearly to match the larger release-distance track.
      const secondCardTrigger = viewportHeight * 0.45;
      const thirdCardTrigger = viewportHeight * 0.95;
      const releaseTrigger = viewportHeight * 1.5;
      const scrollProgress = Math.max(0, Math.min(releaseTrigger, this.#stickyTop - rect.top));

      const now = performance.now();
      if (!this.#lastTimestamp) {
        this.#lastTimestamp = now;
        this.#lastProgress = scrollProgress;
        this.#smoothedProgress = scrollProgress;
      }

      const elapsed = Math.max(now - this.#lastTimestamp, 1);
      const velocity = (scrollProgress - this.#lastProgress) / elapsed;
      const speed = Math.abs(velocity);
      const normalizedSpeed = Math.min(speed / 1.2, 1);
      const smoothingFactor = 0.42 - normalizedSpeed * 0.24;

      this.#smoothedProgress += (scrollProgress - this.#smoothedProgress) * smoothingFactor;
      this.#lastTimestamp = now;
      this.#lastProgress = scrollProgress;

      const hysteresis = viewportHeight * 0.015;
      const secondEnter = secondCardTrigger + hysteresis;
      const thirdEnter = thirdCardTrigger + hysteresis;
      const enterProgress = Math.max(this.#smoothedProgress, scrollProgress);

      let nextActive = this.#active;

      // Only advance forward, never go backward
      if (nextActive === 0) {
        if (cards.length >= 2 && enterProgress >= secondEnter) {
          nextActive = 1;
        }
      } else if (nextActive === 1) {
        if (cards.length >= 3 && enterProgress >= thirdEnter) {
          nextActive = 2;
        }
      }
      // nextActive === 2 remains at 2 (no backward transition)

      this.#setActive(nextActive);

      if (!this.#isCompleted && nextActive === 2 && rect.bottom < 0) {
        this.#isCompleted = true;
        section.classList.add('is-completed');
      }
    }

    #setupCardClickHandlers() {
      this.#cards.forEach((card, index) => {
        card.addEventListener('click', () => {
          this.#userClicked = true;
          this.#setActive(index);
        });
      });
    }

    #setActive(nextActive) {
      if (nextActive === this.#active && this.#started) return;

      this.#active = nextActive;
      // record highest index ever activated so visibility never shrinks
      this.#maxActive = Math.max(this.#maxActive, nextActive);
      const cards = this.#cards;
      const stages = this.#stages;

      for (const [index, card] of cards.entries()) {
        const isActive = index === this.#active;
        const isVisible = index <= this.#maxActive;
        card.classList.toggle('is-active', isActive);
        card.classList.toggle('is-visible', isVisible);
        card.setAttribute('aria-hidden', String(!isVisible));
      }

      for (const [index, stage] of stages.entries()) {
        stage.classList.toggle('is-active', index === this.#active);
      }

    }
  }

  if (!customElements.get('bon-scroll-stats-component')) {
    customElements.define('bon-scroll-stats-component', BonScrollStatsComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
